module.exports = __webpack_public_path__ + "img/dowsh.fd688954.png";